import React, { useState, useEffect } from "react";
import GInput from "../common/input/ginput";
import { renderImg } from "../common/icons/img";
import Checkbox from "../common/input/checkbox";
import { Avtar, WarningIcon } from "../common/icons/svg";
import { countdown } from "../common/helper";
import { AGREE_END, AGREE_TXT, AND, CNTRY_CODE, EML_ID, ENT_CC, ENT_OTP, FL_NAME, MB_NO, OTP_RCV_TXT, OTP_RSND_IN, PRIVACY, PWD_LNG_ERR, SET_PWD, TNC, UR_IP, VAL_EML_ID_REQ, VAL_FL_NAME, VAL_PHN_NO, PLZ_ENT_PWD, RE_CNFRM_PWD, t } from "../../translations/Login";
const SignupForm = (props) => {
    const { data } = props;
    const { email, setEmail } = data;
    const { cccode } = data;
    const { mobile, setMobile } = data;
    const { setSlider } = data;
    const { togglePassword, setTogglePassword } = data;
    const { togglePasswordR, setTogglePasswordR } = data;
    const { password, setPassword, passwordR, setPasswordR } = data;
    const { tncFlag, setTncFLag, setResetting } = data;
    const { signupOtpSent } = data;
    const { blockError } = data;
    const { signupOTP, setSignupOtp } = data;
    const { name, setName } = data;
    const { ipAddress } = props;
    const { resendSignupOTP, setResendSignupOTP, sendSignupOTP } = data;
    const { confirmPassword, setConfirmPassword } = data;
    const [toggleConfirmPassword, setToggleConfirm] = useState(false);

    const { signupTimer } = data;

    useEffect(() => {
        if (signupTimer == true) {
            countdown("mobileClock", 3, 0, setResendSignupOTP);
        }
    }, [signupTimer]);
    return (
        <div>
            <div className="payee-info-inputs">
                <GInput
                    value={email}
                    onChange={setEmail}
                    errMsg={t(VAL_EML_ID_REQ)}
                    label={t(EML_ID)}
                    key={"emailid"}
                    icon={
                        <Avtar
                            fillcolor="#888888"
                            style={{ height: "20px", width: "20px" }}
                        />
                    }
                    iconError={
                        <Avtar
                            fillcolor="red"
                            style={{ height: "20px", width: "20px" }}
                        />
                    }
                    validation="email"
                    disabled={signupOtpSent}
                />
                <GInput
                    value={name}
                    onChange={setName}
                    validation="name"
                    errMsg={t(VAL_FL_NAME)}
                    label={t(FL_NAME)}
                    key={"name"}
                    icon={
                        <Avtar
                            fillcolor="#888888"
                            style={{ height: "20px", width: "20px" }}
                        />
                    }
                    iconError={
                        <Avtar
                            fillcolor="red"
                            style={{ height: "20px", width: "20px" }}
                        />
                    }
                    disabled={signupOtpSent}
                />
                <GInput
                    value={cccode}
                    errMsg={t(ENT_CC)}
                    label={t(CNTRY_CODE)}
                    validation="countrycode"
                    key={"cc"}
                    icon={renderImg("flag-icon")}
                    iconError={renderImg("flag-icon-error")}
                    readonly={true}
                    icon2={renderImg("filter-left-arrow")}
                    onClick={() => setSlider("COUNTRY-CODE")}
                    onIconClick={() => setSlider("COUNTRY-CODE")}
                    disabled={signupOtpSent}
                />
                <GInput
                    type="tel"
                    value={mobile}
                    onChange={setMobile}
                    validation="mobile2"
                    errMsg={t(VAL_PHN_NO)}
                    label={t(MB_NO)}
                    key={"mobileno"}
                    icon={renderImg("phone-icon")}
                    iconError={renderImg("phone-icon-error")}
                    disabled={signupOtpSent}
                />

                {signupOtpSent ? (
                    <React.Fragment>
                        <GInput
                            type={togglePassword ? "text" : "password"}
                            value={signupOTP}
                            onChange={(e) => setSignupOtp(e)}
                            errMsg={t(ENT_OTP)}
                            label={t(ENT_OTP)}
                            key={"password"}
                            icon={renderImg("lock-icon")}
                            iconError={renderImg("lock-icon-error")}
                            icon2={renderImg("view-icon")}
                            onIconClick={() =>
                                setTogglePassword(!togglePassword)
                            }
                            validation="password"
                            max={6}
                        />
                        {blockError ? (
                            ""
                        ) : (
                            <div className="flex otp-instructions">

                                {renderImg("login_error")}
                                <div>
                                    {t(OTP_RCV_TXT)}
                                </div>
                            </div>
                        )}
                        {
                            <div
                                style={{
                                    color: "#444",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    letterSpacing: ".02em",
                                    textAlign: "center",
                                    padding: "10px 0px",
                                }}
                            >
                                {resendSignupOTP === "" ? (
                                    ""
                                ) : resendSignupOTP === "Resend" ? (
                                    <span
                                        style={{ color: "#004F9E", cursor: "pointer" }}
                                        onClick={() => sendSignupOTP()}
                                    >
                                        {t(OTP_SEND_NOW)}
                                    </span>
                                ) : (
                                    <>
                                        <span>{t(OTP_RSND_IN)} </span>{" "}
                                        <span
                                            id="mobileClock"
                                            style={{ color: "red", marginLeft: "4px" }}
                                        ></span>
                                    </>
                                )}
                            </div>
                        }
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <GInput
                            type={togglePassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e)}
                            errMsg={t(PWD_LNG_ERR)}
                            label={t(SET_PWD)}
                            key={"password"}
                            icon={renderImg("lock-icon")}
                            iconError={renderImg("lock-icon-error")}
                            icon2={renderImg("view-icon")}
                            onIconClick={() => setTogglePassword(!togglePassword)}
                            validation="password"
                        />
                        <GInput
                            type={toggleConfirmPassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e)}
                            errMsg={t(PLZ_ENT_PWD)}
                            label={t(RE_CNFRM_PWD)}
                            key={"confirmpassword"}
                            icon={renderImg("lock-icon")}
                            iconError={renderImg("lock-icon-error")}
                            icon2={renderImg("view-icon")}
                            onIconClick={() => setToggleConfirm(!toggleConfirmPassword)}
                            validation="password"
                        />
                    </React.Fragment>

                )}
                {blockError && (
                    <div className="flex otp-wrong">
                        {renderImg("login_error")}
                        <div>{blockError}</div>
                    </div>
                )}
                <div className="flex recaptcha">
                    <div>
                        {ipAddress ? `${t(UR_IP)}: ${ipAddress}` : ""}
                    </div>
                    {/* <ReCAPTCHA
                            sitekey="YOUR_RECAPTCHA_SITE_KEY" // Replace with your reCAPTCHA site key
                            onChange={handleRecaptchaChange}
                        /> */}
                </div>
                <div className="flex tnc-block">
                    <Checkbox
                        active={tncFlag}
                        onClick={() => setTncFLag(!tncFlag)}
                    />
                    <div
                        className="tnc-block-text"
                    // style={{ marginLeft: "10px" }}
                    >
                        {t(AGREE_TXT)}
                        <a href="/reservation_terms" target="_blank"><span> {t(TNC)} </span></a> {/* {t(AND)}{" "}
                        <span>{t(PRIVACY)}</span> {t(AGREE_END)} */}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignupForm;
